<template>
    <div  @click="$emit('CloseSignatory')" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
    </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
        <div class="flex flex-col justify-center  z-40 bg-white w-[800px] text-lg rounded-lg border-[2px] border-[#016B00] relative">
            <div v-if="loader" class="absolute bg-[#00000042] w-full h-full flex justify-center items-center z-45" >
                <span class="loader z-50 text-[#440d0d]"></span>
            </div>
            <div class="pafcpic_header bg-[#016B00] py-3 px-6 ">
                <p class="text-[#ffffff] text-md font-semibold">{{ signatoryTitle }}</p>
             
            </div>
            <div class="pafcpic_body py-6 px-8 flex flex-col gap-2">
                <div class="flex justify-between">
                    <p  v-if="signaType       == '1'" class="text-md text-[#12760A] font-bold mb-2">LEAVE SIGNATORY</p>
                    <p  v-else-if="signaType  == '2'" class="text-md text-[#12760A] font-bold mb-2">CONSIDERATION SIGNATORY</p>
                    <p  v-else-if="signaType  == '3'" class="text-md text-[#12760A] font-bold mb-2">TRAINING REQUISITION SIGNATORY</p>
               
                </div>
                <div class="">
                    <select @change="getSignatory" class="w-full border-[#ACA9A9] border rounded-md py-3 px-2 text-sm text-[#12760A] font-semibold" v-model="rank">
                        <option value="R">RANK AND FILE</option>
                        <option value="S">SUPERVISOR</option>
                        <option value="M">MANAGER</option>
                        <option value="E">EXECUTIVE</option>
                    </select>
                </div>
                <div class="grid grid-cols-4 gap-11 w-full">
                    <select class="col-span-2 border-[#ACA9A9] border rounded-md py-3 px-2 text-sm text-[#12760A] font-semibold" v-model="signatoryName">
                        <option value="" selected disabled>Select Signatory</option>
                        <option v-for="(info,index) in getName" :key="index" :value="info.employee_key">{{ info.full_name }}</option>
                    </select>
                    <button class="col-span-1 bg-[#12760A] text-sm rounded-md text-white" @click="addSignatory('R')">Recommendation</button>
                    <button class="col-span-1 bg-[#12760A] text-sm rounded-md text-white" @click="addSignatory('A')">Approval</button>
                </div>
                <div v-if="signaType == '3'" class="flex gap-3">
                    <button class="bg-[#12760A]   py-2 w-[150px] text-sm rounded-md text-white" @click="addTrainingSignatory('PB')">PROCESS(OHR)</button>
                    <button class=" bg-[#12760A]  py-2 w-[150px] text-sm rounded-md text-white" @click="addTrainingSignatory('RB')">RECOM(OHR)</button>
                    <button class=" bg-[#12760A]  py-2 w-[150px] text-sm rounded-md text-white" @click="addTrainingSignatory('AB')">APV(OHR)</button>
                </div>
                <div class="flex w-full mt-2 gap-1">
                    <div class="w-[50%] flex flex-col  rounded-md px-2 py-1">
                        <p class="text-sm text-[#12760A] font-bold">RECOMMENDED BY:</p>
                        <div v-if="!recommendation"  class="flex gap-8 mt-4 justify-between">
                            <div class="flex flex-col w-full">
                                <p class="text-sm font-semibold text-[#9d9e9d]">NO SIGNATORY FOUND </p>
                            </div>
                        </div>
                        <div v-else v-for="(recommendation,index) in recommendation" :key="index" class="flex gap-8 mt-4 justify-between">
                            <div class="flex flex-col">
                                <p class="text-sm font-semibold text-[#12760A]">{{ recommendation.employee_name }}</p>
                                <p class="text-xs text-[#888]">Immediate Superior</p>
                            </div>
                            <button class="h-[30px] bg-[#12760A] px-4 rounded-md text-white text-xs py-1" @click="deleteSignatorybyid(recommendation.id)">X</button>
                        </div>
                    </div>
                    <div class="w-[50%]  rounded-md px-2 py-1">
                        <p class="text-sm text-[#12760A] font-bold">APPROVED BY:</p>
                        <div v-if="approval == null"  class="flex gap-8 mt-4 justify-between">
                            <div class="flex flex-col w-full">
                                <p class="text-sm font-semibold text-[#9d9e9d]">NO SIGNATORY FOUND</p>
                            </div>
                        </div>
                        <div v-else v-for="(approval,index) in approval" :key="index" class="flex gap-8 mt-4 justify-between">
                            <div class="flex w-full">
                                <div class="flex flex-col w-full">
                                    <p class="text-sm font-semibold text-[#12760A]">{{ approval.employee_name }}</p>
                                    <p class="text-xs text-[#888]">Division / Office Executive</p>
                                </div>
                                <button class="h-[30px] bg-[#12760A] px-4 rounded-md text-white text-xs py-1" @click="deleteSignatorybyid(approval.id)">X</button>
                            </div> 
                        </div>
                    </div>
                </div>
                <div v-if="signaType == '3'" class="flex  flex-col w-full mt-8 gap-11 ">
                    <div class="flex w-full gap-11">
                        <div class="w-[33.3%] flex flex-col">
                            <p class="text-sm text-[#12760A] font-bold">PROCCESS BY(OHR)</p>
                            <div v-if="!proccessBy"  class="flex gap-8 mt-4 justify-between">
                                <div class="flex flex-col w-full">
                                    <p class="text-sm font-semibold text-[#9d9e9d]">NO SIGNATORY FOUND </p>
                                </div>
                            </div>
                            <div v-else v-for="(processs,index) in proccessBy" :key="index" class="flex gap-8 mt-4 justify-between">
                                <div class="flex flex-col">
                                    <p class="text-sm font-semibold text-[#12760A]">{{ processs.employee_name }}</p>
                                    <p class="text-xs text-[#888]">Learning Specialist</p>
                                </div>
                                <button class="h-[30px] bg-[#12760A] px-4 rounded-md text-white text-xs py-1" @click="deleteSignatorybyid(processs.mendation.id)">X</button>
                            </div>
                        </div>
                        <div class="w-[33.3%]">
                            <p class="text-sm text-[#12760A] font-bold">RECOMMENDED BY(OHR)</p>
                            <div v-if="recomBy == null"  class="flex gap-8 mt-4 justify-between">
                                <div class="flex flex-col w-full">
                                    <p class="text-sm font-semibold text-[#9d9e9d]">NO SIGNATORY FOUND</p>
                                </div>
                            </div>
                            <div v-else v-for="(approval,index) in recomBy" :key="index" class="flex gap-8 mt-4 justify-between">
                                <div class="flex w-full">
                                    <div class="flex flex-col w-full">
                                        <p class="text-sm font-semibold text-[#12760A]">{{ approval.employee_name }}</p>
                                        <p class="text-xs text-[#888]">Learning and Development Manager</p>
                                    </div>
                                    <button class="h-[30px] bg-[#12760A] px-4 rounded-md text-white text-xs py-1" @click="deleteSignatorybyid(approval.id)">X</button>
                                </div> 
                            </div>
                        </div>
                        <div class="w-[33.3%]">
                            <p class="text-sm text-[#12760A] font-bold">APPROVAL BY(OHR)</p>
                            <div v-if="apvBy == null"  class="flex gap-8 mt-4 justify-between">
                                <div class="flex flex-col w-full">
                                    <p class="text-sm font-semibold text-[#9d9e9d]">NO SIGNATORY FOUND</p>
                                </div>
                            </div>
                            <div v-else v-for="(approval,index) in apvBy" :key="index" class="flex gap-8 mt-4 justify-between">
                                <div class="flex w-full">
                                    <div class="flex flex-col w-full">
                                        <p class="text-sm font-semibold text-[#12760A]">{{ approval.employee_name }}</p>
                                        <p class="text-xs text-[#888]">Vice President for Human Resources</p>
                                    </div>
                                    <button class="h-[30px] bg-[#12760A] px-4 rounded-md text-white text-xs py-1" @click="deleteSignatorybyid(approval.id)">X</button>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#0080002a] border-t font-medium">
            <button @click="$emit('CloseSignatory')" class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md">Close</button>
        </div>
        </div>
    </div>

    <div v-if="addSign">
        <Prompt type="ADDSIGN" @close="addSign = false"/>
    </div>

    <div v-if="delSign">
        <Prompt type="DELSIGN" @close="delSign = false"/>
    </div>

</template>

<script>
import Prompt from '../Prompt/RequestPromt.vue'
import { defineComponent } from "vue";
import Services from "../../../services/admin"


export default defineComponent({
     components:{
        Prompt

     },
     data() {
        return {
            loader: false,
            rank:'R',
            signatoryName: '',
            Signatory:     '',
            division_key:  null,
            department_key:null,
            section_key:   null,
            recommendation: '',
            approval:       '',
            addSign:        false,
            delSign:        false,
            signaType:'',

            proccessBy:     '',
            recomBy:        '',
            apvBy:          '',
            trainSignatory:'',
        }
     },
     props:{
        signatoryTitle : {
            type: String 
     },
        getName : {
            type: Object 
     },
        div_key : {
            type: String 
     },
        dep_key : {
            type: String 
     },
        sec_key : {
            type: String 
     },
     signatoryType : {
            type: String 
     },
     
     
    },
     mounted() {
      
        this.division_key   = this.div_key
        this.deparment_key  = this.dep_key
        this.section_key    = this.sec_key
        this.signaType      = this.signatoryType
        this.getSignatory()
       
     },
     methods: {
        async getSignatory(){
            this.loader        = true

            this.Signatory      = null
            this.recommendation = null
            this.approval       = null
            const success       = await Services.getSignatory(this.division_key,this.deparment_key,this.section_key,this.rank,this.signaType)
            this.Signatory      = success.data

            if(this.Signatory !=null){
                this.recommendation = this.Signatory.filter(Signatory=>Signatory.signatory_type == 'R')
                this.approval       = this.Signatory.filter(Signatory=>Signatory.signatory_type == 'A')
                
                if(!this.recommendation.length){
                    this.recommendation = null
                }
                if(!this.approval.length){
                    this.approval = null
                }
            }
            if(this.signaType === '3'){
                const success       = await Services.getTrainingSignatory(this.division_key,this.deparment_key,this.section_key,this.rank,this.signaType)
                this.trainSignatory = success.data
                this.proccessBy   = this.trainSignatory.filter(Signatory=>Signatory.signatory_type == 'PB')
                this.recomBy      = this.trainSignatory.filter(Signatory=>Signatory.signatory_type == 'RB')
                this.apvBy        = this.trainSignatory.filter(Signatory=>Signatory.signatory_type == 'AB')

                if(!this.proccessBy.length){
                    this.proccessBy = null
                }
                if(!this.recomBy.length){
                    this.recomBy = null
                }
                if(!this.apvBy.length){
                    this.apvBy = null
                }
            }

            this.loader = false
        },
        async addSignatory(signatory_type){

            this.loader             = true
            const success           = await Services.addSignatory(this.division_key,this.deparment_key,this.section_key,this.rank,this.signatoryName,signatory_type,this.signaType)
            this.Signatory          = success.data
            this.getSignatory()
            this.loader             = false
            this.addSign            = true
        },

        async addTrainingSignatory(signatory_type){
            this.loader             = true
            const success           = await Services.addtrainingSignatory(this.signatoryName,signatory_type)
            if(success.success ==  true){
                this.getSignatory()
                this.loader             = false
                this.addSign            = true
            }
            else{
                this.loader             = false
            }
          

            
        },
        async deleteSignatorybyid(id){
            this.loader                = true
            const success              = await Services.deleteSignatory(id)
            this.deleteSignatoryid     = success.data
            this.getSignatory()
            this.loader                = false
            this.delSign               = true
        }
     },
});



</script>

<style scoped>
.loader {
    width: 48px;
    height: 48px;
    border: 5px solid #ffffff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 

</style>